import 'babel-polyfill'
import App from './App.vue'
import vuetify from './plugins/vuetify'
import { createStore } from './store'
import { createRouter } from './router'
import { sync } from 'vuex-router-sync'

// Expose a factory function that creates a fresh set of store, router,
// app instances on each call (which is called for each SSR request)
export const createApp = () => {
    // create store and router instances
    const store = createStore();
    const router = createRouter();

    // sync the router with the vuex store.
    // this registers `store.state.route`
    sync(store, router);

    // create the app instance.
    // here we inject the router, store and ssr context to all child components,
    // making them available everywhere as `this.$router` and `this.$store`.
    let obj = {
        router,
        store,
        vuetify,
        render: h => h(App),
    };
    // expose the app, the router and the store.
    // note we are not mounting the app here, since bootstrapping will be
    // different depending on whether we are in a browser or on the server.
    return obj;
};



// WEBPACK FOOTER //
// src/app.js